import * as React from 'react';
import { useSelector } from 'react-redux';
import { DashboardMenuItem, Menu, MenuItemLink, getResources } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import DefaultIcon from '@material-ui/icons/ViewList';

const useStyles = makeStyles({
    menu: {
        marginTop: '0.8em',
    },
});

const MyMenu = (props) => {
    const classes = useStyles(props);
    const resources = useSelector(getResources);
    const open = useSelector(state => state.admin.ui.sidebarOpen);
    return (
        <>
            {open ? (
                <>
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '1.5em'}}>
                        <Box component="img" sx={{height: 50, marginRight: 8 }} src='images/njrxp_logo.svg' />
                        <Box component="span" sx={{fontWeight: 500, marginRight: 15}}>NJR EXPERIENCE</Box>
                    </Box>
                    <div style={{height: 4}} />
                    <Box sx={{display: 'flex'}}>
                        <Box
                            component={'div'}
                            sx={{
                                width: '100%',
                                height: 2,
                                backgroundColor: 'black',
                                margin: '0 8px'
                            }}
                        />
                        <Box sx={{width: '2px'}} />
                    </Box>
                </>
            ) : undefined}
            <Menu {...props} className={classes.menu}>
                <DashboardMenuItem />
                {resources.map(resource => (
                    <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={
                            (resource.options && resource.options.label) ||
                            resource.name
                        }
                        leftIcon={
                            resource.icon ? <resource.icon /> : <DefaultIcon />
                        }
                        onClick={props.onMenuClick}
                        sidebarIsOpen={open}
                    />
                ))}
                {/* add your custom menus here */}
            </Menu>
        </>
    );
};

export default MyMenu;